module.exports = __webpack_public_path__ + "img/d201009-1.b18bb7b7.jpg";